// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6186":"58d9e5d1","6341":"567ff11d","8247":"451e213a","8784":"58d9e5d1","8927":"2ddcc344"}[chunkId] + ".chunk.css";
};